require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-medicinenet-treatment.json") })
        }
      }, "path---article-medicinenet-treatment");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-medicinenet-treatment!./.cache/json/article-medicinenet-treatment.json
// module id = 360
// module chunks = 231608221292675